var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"sheet-availability-text"},[_vm._v(" "+_vm._s(_vm.availabilityText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }